import React, { useState, useEffect } from 'react';

import { Container, QuestionsContainer, PageTitle, Table } from '../components/tables/Style'
import { AddButton, UpdateButton, DeleteButton } from '../components/tables/Buttons'
import { InputArea } from './Styles/Inputs';

import { getAllCollection, addToCollection, deleteFromCollection } from '../services/database';

import { withRouter } from 'react-router-dom';


const News = ({ history }) => {
    //State
    const [rows, setRows] = useState([]);
    const [showAddRow, setShowAddRow] = useState(false);
    const [inputs, setInputs] = useState({
        date: '',
        title: '',
    });

    useEffect(() => {
        getAllCollection('news').then(result => {
            setRows(result.data);
        })
    }, []);

    //Functions
    const handleAddButton = () => {
        setShowAddRow(true);
    }
const handleMetaEdit = (id) => {
    history.push('/edit-news-meta', {
        id: id
    });
};
    const handleUpdate = (id) => {
        history.push('/edit-news', {
            id: id
        });
    }

    const handleSaveButton = () => {
        if (inputs.date && inputs.title) {
            setShowAddRow(false);
            addToCollection(
                'news',
                (rows.length > 0 ? /*parseInt(rows[rows.length - 1].id)*/Math.max.apply(Math, rows.map(function (o) { return o.id; })) + 1 : 0
                ).toString(),
                {
                    id: rows.length > 0 ? /*parseInt(rows[rows.length - 1].id)*/Math.max.apply(Math, rows.map(function (o) { return o.id; })) + 1 : 0
                    ,
                    date: inputs.date,
                    title: inputs.title
                }
            );
            getAllCollection('news').then(result => {
                setRows(result.data);
            })
            setInputs({
                date: '',
                title: ''
            });
        }
    }

    const handleDelete = (dateId) => {
        deleteFromCollection('news', dateId);
        getAllCollection('news').then(result => {
            setRows(result.data);
        })
    }

    return (
        <Container>
            <PageTitle>Novosti</PageTitle>
            <QuestionsContainer>
                <AddButton onClick={() => handleAddButton()}>
                    <i className="fas fa-plus-circle"></i>
                    <h1>Dodaj</h1>
                </AddButton>
                <Table>
                    <tr>
                        <th style={{ width: '2%' }}>ID</th>
                        <th style={{ width: '15%' }}>Datum objave</th>
                        <th style={{ width: '68%' }}>Naslov</th>
                        <th style={{ width: '15%' }}></th>
                    </tr>
                    <tr style={{ backgroundColor: '#222831', display: showAddRow ? 'revert' : 'none' }}>
                        <td>{rows.length > 0 ? /*parseInt(rows[rows.length - 1].id)*/Math.max.apply(Math, rows.map(function (o) { return o.id; })) + 1 : 0
                        }</td>
                        <td>
                            <InputArea
                                rows={8}
                                onChange={(e) => setInputs({ ...inputs, date: e.target.value })}
                                value={inputs.date}
                            />
                        </td>
                        <td>
                            <InputArea
                                rows={8}
                                onChange={(e) => setInputs({ ...inputs, title: e.target.value })}
                                value={inputs.title}
                            />
                        </td>
                        <td>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                <AddButton onClick={() => handleSaveButton()}>
                                    <h1>Potvrdi</h1>
                                </AddButton>
                            </div>
                        </td>
                    </tr>
                    {rows.length > 0 ? rows.map(row =>
                        <tr key={'row_id_' + row.id}>
                            <td>{row.id}</td>
                            <td>{row.date}</td>
                            <td>{row.title}</td>
                            <td>
                                <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                                    
                                    <UpdateButton onClick={() => handleUpdate(row.id)}>
                                        <i className="fas fa-edit"></i>
                                    </UpdateButton>
                                    <DeleteButton onClick={() => handleDelete(row.id)}>
                                        <i className="fas fa-trash-alt"></i>
                                    </DeleteButton>
                                    <UpdateButton onClick={() => handleMetaEdit(row.id)}>
    <i className="fas fa-tags"></i>
</UpdateButton>
                                </div>
                            </td>
                        </tr>
                    )
                        : false
                    }
                </Table>
            </QuestionsContainer>
        </Container>
    )
}

export default withRouter(News);